import { Button } from 'reactstrap';
import { FaEdit } from 'react-icons/fa';
import { GlobalSettingsDto } from '@repo/common-types';

interface SettingRowProps {
  setting: GlobalSettingsDto;
  onEdit: (setting: GlobalSettingsDto) => void;
}

const SettingRow = ({ setting, onEdit }: SettingRowProps) => {
  const formatKey = (key: string) => {
    return key.replace(/([A-Z])/g, ' $1').replace(/^./, (str) => str.toUpperCase());
  };

  const formatValue = (value: string, type?: string) => {
    if (type === 'BOOLEAN') {
      return value === 'true' ? 'Yes' : 'No';
    }
    if (value.length > 50) {
      return value.substring(0, 50) + '...';
    }
    return value;
  };

  return (
    <tr>
      <td>
        <strong>{formatKey(setting.key)}</strong>
        {setting.description && <div className="text-muted small">{setting.description}</div>}
      </td>
      <td>
        <span title={setting.value}>{formatValue(setting.value, setting.type)}</span>
      </td>
      <td>
        <span className="badge bg-info">{setting.type || 'STRING'}</span>
      </td>
      <td>
        <Button
          color="outline-primary"
          size="sm"
          onClick={() => onEdit(setting)}
          className="d-flex align-items-center gap-1"
        >
          <FaEdit />
        </Button>
      </td>
    </tr>
  );
};

export default SettingRow;
